/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import {createGlobalStyle} from "styled-components";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

const mavenProRegular = `${WealthyEnv.WEALTHY_FONT}/maven-pro-regular.woff` ;
const mavenProBold = `${WealthyEnv.WEALTHY_FONT}/maven-pro-extra-bold.woff` ;
const mavenProMedium = `${WealthyEnv.WEALTHY_FONT}/maven-pro-medium.ttf`;
const mavenProExtraBold = `${WealthyEnv.WEALTHY_FONT}/maven-pro-extra-bold.woff`;
const dmSerifRegular = `${WealthyEnv.WEALTHY_FONT}/dm-serif-regular.woff`;
const dmSerifItalic = `${WealthyEnv.WEALTHY_FONT}/dm-serif-italic.woff`;
const latoRegular = `${WealthyEnv.WEALTHY_FONT}/Lato-Regular.ttf`;
const poppinsLight = `${WealthyEnv.WEALTHY_FONT}/Poppins-Light.ttf`;
const poppinsRegular = `${WealthyEnv.WEALTHY_FONT}/Poppins-Regular.woff`;
const poppinsBold = `${WealthyEnv.WEALTHY_FONT}/Poppins-Bold.woff`;
const workSansMedium = `${WealthyEnv.WEALTHY_FONT}/WorkSans-Medium.woff`;
const workSansSemiBold = `${WealthyEnv.WEALTHY_FONT}/WorkSans-SemiBold.woff`;
const workSansBold = `${WealthyEnv.WEALTHY_FONT}/WorkSans-Bold.woff`;
const abrilFatface = `${WealthyEnv.WEALTHY_FONT}/abril-fatface.ttf`;

const arrowDown = `${WealthyEnv.GREY_MATTER_CDN_URL}/purple-down.png`;

const NewGlobalStyle = createGlobalStyle`
  @font-face {
    font-family: MavenPro;
    src: url(${mavenProRegular}) format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: MavenPro-Bold;
    src: url(${mavenProBold}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: MavenPro-Medium;
    src: url(${mavenProMedium}) format("tff");
    font-display: swap;
  }

   @font-face {
    font-family: MavenProExtra-Bold;
    src: url(${mavenProExtraBold}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: DmSerif-Regular;
    src: url(${dmSerifRegular}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: DmSerif-Italic;
    src: url(${dmSerifItalic}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: Poppins-Light;
    src: url(${poppinsLight}) format("tff");
    font-display: swap;
  }

    @font-face {
    font-family: Poppins-Regular;
    src: url(${poppinsRegular}) format("woff");
    font-display: swap;
  }

   @font-face {
    font-family: Poppins-Bold;
    src: url(${poppinsBold}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: Lato-Regular;
    src: url(${latoRegular}) format("tff");
    font-display: swap;
  }

    @font-face {
    font-family: WorkSans-Medium;
    src: url(${workSansMedium}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: WorkSans-Semibold;
    src: url(${workSansSemiBold}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: WorkSans-Bold;
    src: url(${workSansBold}) format("woff");
    font-display: swap;
  }

    @font-face {
    font-family: Abril-Fatface;
    src: url(${abrilFatface}) format("tff");
    font-display: swap;
  }

  body{
    font-family: MavenPro;
  }

  .btn {
    padding: 1rem 4rem;
    border-radius: 5px;
    position: relative;
    z-index: 1;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    font-size: 1.6rem;
    line-height: 1.2;
    font-weight: 500;
  }

  .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 0;
    z-index:-1;
    transition: all 0.2s ease-in-out;
  }

  .btn:hover::before {
    width:100%;
  }

  .btn-bordered {
    border: 1px solid ${colors.primary};
    background-color: ${colors.white};
    color: ${colors.primary};
  }

  .btn-bordered:hover {
    color: ${colors.white};
  }

  .btn-bordered::before {
    background-color: ${colors.primary};
  }

  .btn-primary {
    border: 1px solid ${colors.primary};
    background-color: ${colors.primary};
    color: ${colors.white};
  }

  .btn-primary:hover {
    color: ${colors.primary};
  }

  .btn-primary::before {
    background-color: ${colors.white};
  }

  .badge {
    font-weight: 500;
    padding: 0.3rem 1.4rem;
    border-radius: 4px;
    font-size: 1.2rem;
    display: inline-block;
  }

  .badge-primary {
    background-color: ${colors.primary};
    color: ${colors.white};
  }

  .badge-border-primary {
    color: ${colors.primary};
    border: 1px solid ${colors.primary};
  }

  .page-title {
    color: #fff;
    font-size: 6rem;
  }

  @media (max-width:992px) {
    .page-title {
      font-size: 4rem;
    }
  }

  .page-tag-line {
    color: #fff;
    font-size: 2.2rem;
    max-width: 430px;
    margin-top: 2rem;
  }

  @media (max-width:768px) {
    .page-tag-line {
      margin: 2rem auto 0;
    }
  }

  .select-bordered {
    border: 1px solid ${colors.primary};
    background-color: #fff;
    appearance: none;
    border-radius: 5px;
    min-width: 140px;
    font-size: 1.6rem;
    background-image: url(arrowDown);
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 1.6rem;
  }

  .select-bordered > div {
     border-color: transparent;
  }

  select:invalid, select option[value=""] {
    color: red;
  }

  .transform-unset {
    transform: unset!important;
  }
`;

export default NewGlobalStyle;
